import { USER_FLAGS } from '../actions/UserFlagsActions'

/*
 * User flags of the Open20 navigation.
 */
function initialState() {
  return null
}

export default function userFlags(state = initialState(), action) {
  switch (action.type) {
    case USER_FLAGS:
      return action.payload
    default:
      return state
  }
}
